import { render, staticRenderFns } from "./ctlist.vue?vue&type=template&id=6ba65170&scoped=true&"
import script from "./ctlist.vue?vue&type=script&lang=js&"
export * from "./ctlist.vue?vue&type=script&lang=js&"
import style0 from "./ctlist.vue?vue&type=style&index=0&id=6ba65170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba65170",
  null
  
)

export default component.exports